import React, { useEffect, useState } from 'react';
import { Input, Checkbox, Button, Dropdown, Modal, Radio } from 'app/components';
import { Question, CheckCircle, CloudArrowUp } from '@phosphor-icons/react';
import './style';
import { GST_REGISTERED_STATES, indianStates } from './indianStates.js';
import FileComponent from './fileComponent.jsx';
import PublishEventModal from './publishEventModal.jsx';
import UploadModal from './uploadModal.jsx';
import SuccessModal from './successModal.jsx';
import UploadAadharModal from './uploadAadhar.jsx';
import { useSelector } from 'react-redux';
import { createBusinessConfig, updateBusinessConfig, uploadImage } from '../../api.js';
import VendorModal from './vendorModal.jsx';
import { useNavigate } from 'react-router-dom';
import { IMAGE_TAGS } from '../../../../constants/imageTags.js';
import { generateUniqueId } from '../../../../utils/commonUtils.js';
import GstForm from '../step-2/gstForm.jsx';

const VerificationForm = ({ eventData, saveEvent }) => {
  console.log("kok");
  const { businessConfig = {} } = useSelector((state) => state.eventCreate);
  const { userData } = useSelector((state) => state.app);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    is_gst_registered: true,
    company_name: '',
    address_details: {
      address_id: 0,
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      pin_code: '+91',
      is_primary: true,
      country: 'India',
      country_code: '+91',
    },
    alternate_proof_data: '', 
    proof_data: '',          
    uploadedFiles: [],       
    panFileType: 'pdf',       
    secondaryFileType: 'pdf', 
    secondary_proof_id: '',  
  });
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [errors, setErrors] = useState({
    panNumberError: '',
    gstCodeError: '',
    aadharError: '',
  });
  const [modalData, setModalData] = useState({
    uploadFileName: '',
    uploadFileName1: '',
    uploadFileName2: '',
    uploadTitle: '',
    isUploadModalOpen: false,
    isUploadAadharModalOpen: false,
    reuploadText: '',
    reuploadText1: '',
    reuploadText2: '',
    isPublishModalOpen: false,
    isSuccessModalOpen: false,
    isVendorModalOpen: false,
    isGstConfirmationModalOpen: false,
  });
  const [acceptLoading, setAcceptLoading] = useState(false);
  const isDisabled = !(
    formData.company_name?.trim()?.length &&
    formData.address_details?.address_line_1?.trim()?.length &&
    ((formData.is_gst_registered && formData.uploadedFiles.length >= 1 && isPolicyAccepted && isFormValid) ||
     (formData.is_gst_registered === false && 
      ((formData.panFileType === 'pdf' ? 1 : 2) + (formData.secondaryFileType === 'pdf' ? 1 : 2) <= formData.uploadedFiles.length) && 
      isPolicyAccepted && isFormValid))
  );

  useEffect(() => {
    validateForm();
  }, [
    formData.is_gst_registered,
    formData?.address_details?.state,
    formData.alternate_proof_data,
    errors.panNumberError,
    formData.proof_data,
    errors.gstCodeError,
    errors.aadharError,
    formData.secondary_proof_id,
  ]);

  const validateForm = () => {
    if (formData.is_gst_registered) {
      if (
        formData.address_details?.state &&
        formData.alternate_proof_data.length === 10 &&
        !errors.panNumberError &&
        formData.proof_data.length === 15 &&
        !errors.gstCodeError
      ) {
        setIsFormValid(true);
      } else {
        setIsFormValid(false);
      }
    } else {
      if (formData.proof_data.length === 10 && !errors.panNumberError && formData.secondary_proof_id) {
        setIsFormValid(true);
      } else {
        setIsFormValid(false);
      }
    }
  };

  const handleAcceptedChange = () => {
    setIsPolicyAccepted((prev) => !prev);
  };

  const handleStateChange = (id) => {
    const selectedStateValue = indianStates.find(
      (state) => state.id === id,
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      address_details: {
        ...prevFormData?.address_details,
        state: selectedStateValue.label,
      },
      proof_data: prevFormData?.is_gst_registered ?
          selectedStateValue ? selectedStateValue.gstCode : '' :
          prevFormData.proof_data 
    }));
  };

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value.toUpperCase() });
  };

  const validatePanNumber = (field) => {
    const panRegex = /^[A-Z]{5}\d{4}[A-Z]$/;
    setErrors({
      ...errors,
      panNumberError: panRegex.test(formData[field]) ? '' : 'Please enter a valid PAN number',
    });
  };

  const handleGstCodeChange = (e) => {
    const prefix = formData.proof_data.slice(0, 2);
    const updatedGstValue = prefix + e.target.value.toUpperCase();
    setFormData({ ...formData, proof_data: updatedGstValue });
    validateGstCode(updatedGstValue);
  };

  const validateGstCode = (value = formData.proof_data) => {
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}$/;
    if (gstRegex.test(value)) {
      setErrors({ ...errors, gstCodeError: '' });
    } else {
      setErrors({ ...errors, gstCodeError: 'Please enter a valid GSTIN number' });
    }
  };

  const handleAadharChange = (e) => {
    let value = e.target.value.replace(/\s+/g, '');
    if (value.length > 12) value = value.slice(0, 12);
    value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
    setFormData({ ...formData, proof_data: value });
  };

  const validateAadhar = () => {
    const aadharRegex = /^\d{4}\s\d{4}\s\d{4}$/;
    if (aadharRegex.test(formData.proof_data)) {
      setErrors({ ...errors, aadharError: '' });
    } else {
      setErrors({ ...errors, aadharError: 'Please enter a valid Aadhar number' });
    }
  };

  const handleFileUpload = () => {
    if (formData.is_gst_registered) {
      setModalData({
        ...modalData,
        uploadTitle: 'Upload your GST certificate',
        uploadFileName: 'Upload GST',
        isUploadModalOpen: true,
        reuploadText: 'Re-upload certificate',
      });
    } else {
      setModalData({
        ...modalData,
        uploadTitle: 'Upload your PAN card',
        uploadFileName1: 'Upload PAN',
        uploadFileName2: 'Upload PAN',
        reuploadText1: 'Re-upload PAN',
        reuploadText2: 'Re-upload PAN',
        isUploadAadharModalOpen: true,
      });
    }
  };

  const handleFileSubmit = (file) => {
    const files = [file];
    setFormData({
      ...formData,
      uploadedFiles: files,
      panFileType: 'pdf', // GST is always PDF
    });
    setModalData({ ...modalData, isUploadModalOpen: false });
  };

  const handleFilesSubmit = (data) => {
    if (!data || typeof data !== 'object') {
      console.error('handleFilesSubmit called with invalid data:', data);
      return;
    }

    const { files, panFileType, secondaryFileType } = data;
    if (!Array.isArray(files)) {
      console.error('Files is not an array:', files);
      return;
    }

    console.log('Files received in handleFilesSubmit:', files.map(f => f.name));
    console.log('panFileType:', panFileType, 'secondaryFileType:', secondaryFileType);

    const panFileCount = panFileType === 'pdf' ? 1 : 2;
    const secondaryFileCount = secondaryFileType === 'pdf' ? 1 : 2;

    const panFiles = files.slice(0, panFileCount);
    const secondaryFiles = files.slice(panFileCount, panFileCount + secondaryFileCount);

    console.log('panFiles:', panFiles.map(f => f.name));
    console.log('secondaryFiles:', secondaryFiles.map(f => f.name));
    console.log('panFileCount:', panFileCount, 'secondaryFileCount:', secondaryFileCount);

    setFormData({
      ...formData,
      uploadedFiles: files,
      panFileType,
      secondaryFileType,
    });
    setModalData({ ...modalData, isUploadAadharModalOpen: false });
  };

  const handleFileDelete = (index) => {
    setFormData((prev) => {
      const newUploadedFiles = prev.uploadedFiles.filter((_, i) => i !== index);
      const panFileCount = prev.panFileType === 'pdf' ? 1 : 2;
      const remainingPanFiles = newUploadedFiles.slice(0, panFileCount);
      const remainingSecondaryFiles = newUploadedFiles.slice(panFileCount);

      return {
        ...prev,
        uploadedFiles: newUploadedFiles,
        panFileType: remainingPanFiles.length <= 1 ? 'pdf' : 'png',
        secondaryFileType: remainingSecondaryFiles.length <= 1 ? 'pdf' : 'png',
      };
    });
  };

  const handlePublishEvent = () => {
    setModalData((prev) => ({
      ...prev,
      isPublishModalOpen: true,
    }));
  };

  const uploadProofImages = () => {
    const proofImages = formData.uploadedFiles.filter((item) => item instanceof File);
    const promiseList = [];

    proofImages.forEach((img, index) => {
      let tag;
      const panFileCount = formData.panFileType === 'pdf' ? 1 : 2;

      if (formData.is_gst_registered) {
        tag = IMAGE_TAGS.GST; // Use GST tag for registered users
      } else {
        if (index < panFileCount) {
          // PAN files
          if (formData.panFileType === 'pdf') {
            // Single file (PDF or single image)
            tag = IMAGE_TAGS.PAN_CARD;
          } else {
            // Two files (front and back)
            tag = index === 0 ? IMAGE_TAGS.PAN_CARD : IMAGE_TAGS.PAN_CARD_BACK;
          }
        } else {
          // Secondary ID files
          const secondaryIndex = index - panFileCount;
          if (formData.secondaryFileType === 'pdf') {
            // Single file (PDF or single image)
            switch (formData.secondary_proof_id) {
              case 'Aadhar Card':
                tag = IMAGE_TAGS.AADHAR;
                break;
              case 'Passport':
                tag = IMAGE_TAGS.PASSPORT;
                break;
              case 'Driving License':
                tag = IMAGE_TAGS.DRIVING_LICENSE;
                break;
              default:
                tag = IMAGE_TAGS.OTHERS;
            }
          } else {
            // Two files (front and back)
            switch (formData.secondary_proof_id) {
              case 'Aadhar Card':
                tag = secondaryIndex === 0 ? IMAGE_TAGS.AADHAR : IMAGE_TAGS.AADHAR_BACK;
                break;
              case 'Passport':
                tag = secondaryIndex === 0 ? IMAGE_TAGS.PASSPORT : IMAGE_TAGS.PASSPORT_BACK;
                break;
              case 'Driving License':
                tag = secondaryIndex === 0 ? IMAGE_TAGS.DRIVING_LICENSE : IMAGE_TAGS.DRIVING_LICENSE_BACK;
                break;
              default:
                tag = secondaryIndex === 0 ? IMAGE_TAGS.OTHERS : IMAGE_TAGS.OTHERS; // No front/back for "Others"
            }
          }
        }
      }

      promiseList.push(
        uploadImage({
          image: img,
          tag,
          fileName: `${userData?.smp_user_id || userData?._id || generateUniqueId()}_${tag}`,
          loaderId: 'org-proof-upload',
        })
      );
    });

    return promiseList;
  };

  const showSuccessModal = () => {
    setModalData((prev) => ({
      ...prev,
      isPublishModalOpen: false,
      isVendorModalOpen: false,
      isSuccessModalOpen: true,
    }));
  };

  const handleConfirm = () => {
    setAcceptLoading(true);
    const businessConfigData = { ...formData };
    delete businessConfigData.uploadedFiles;
    delete businessConfigData.panFileType;
    delete businessConfigData.secondaryFileType;
    delete businessConfigData.secondary_proof_id; // Replace with secondary_proof_data

    // Add secondary_proof_data
    businessConfigData.secondary_proof_data = formData.is_gst_registered ? '' : formData.secondary_proof_id;

    Promise.all(uploadProofImages()).then((resp) => {
      const imageIds = resp.map((r) => r?.data?.data?.image_id);
      console.log('Image IDs after upload:', imageIds);

      if (formData.is_gst_registered) {
        businessConfigData.proof_image = {
          type: 'pdf', // GST is always a single file
          front: imageIds[0],
          back: ''
        };
      } else {
        const panFileCount = formData.panFileType === 'pdf' ? 1 : 2;
        const secondaryFileCount = formData.secondaryFileType === 'pdf' ? 1 : 2;

        console.log('panFileType:', formData.panFileType, 'panFileCount:', panFileCount);
        console.log('secondaryFileType:', formData.secondaryFileType, 'secondaryFileCount:', secondaryFileCount);

        // PAN files
        businessConfigData.proof_image = {
          type: formData.panFileType,
          front: imageIds[0],
          back: formData.panFileType === 'pdf' ? '' : imageIds[1]
        };

        // Secondary ID files
        businessConfigData.secondary_proof_image = {
          type: formData.secondaryFileType,
          front: imageIds[panFileCount],
          back: formData.secondaryFileType === 'pdf' ? '' : imageIds[panFileCount + 1]
        };
      }

      if (!userData?.business_config_id) {
        createBusinessConfig({
          business_config_id: 0,
          ...businessConfigData,
        }).then(() => {
          saveEvent(eventData, () => {
            showSuccessModal();
            setAcceptLoading(false);
          }, true);
        }).catch(() => setAcceptLoading(false));
      } else {
        updateBusinessConfig(
          userData?.business_config_id,
          { ...businessConfig, ...businessConfigData },
        ).then(() => {
          saveEvent(eventData, () => {
            showSuccessModal();
            setAcceptLoading(false);
          }, true);
        }).catch(() => setAcceptLoading(false));
      }
    }).catch((error) => {
      console.error('Upload failed:', error);
      setAcceptLoading(false);
    });
  };

  const handleSuccessConfirm = () => {
    setModalData((prev) => ({ ...prev, isSuccessModalOpen: false }));
    navigate('/events', { state: 'publish-success' });
  };

  const onChangeData = (e, key) => {
    if (key === 'company_name') {
      setFormData((prev) => ({ ...prev, company_name: e?.target?.value, contact_first_name: e?.target?.value }));
    } else {
      setFormData((prev) => ({ ...prev, [key]: e?.target?.value }));
    }
  };

  const onChangeAddress = (e, key) => {
    setFormData((prev) => ({ ...prev, address_details: { ...prev?.address_details, [key]: e?.target?.value } }));
  };

  const handleSecondaryIdChange = (id) => {
    setFormData((prev) => ({
      ...prev,
      secondary_proof_id: id,
      uploadedFiles: [],
      panFileType: 'pdf',
      secondaryFileType: 'pdf',
    }));
  };

  const resetFileUploadState = () => {
    setFormData((prev) => ({
      ...prev,
      uploadedFiles: [],
      panFileType: 'pdf',
      secondaryFileType: 'pdf',
    }));
    setModalData((prev) => ({
      ...prev,
      isUploadModalOpen: false,
      isUploadAadharModalOpen: false,
    }));
  };

  const renderUploadedFiles = () => {
    if (formData.uploadedFiles.length === 0) return null;

    return formData.uploadedFiles.map((file, index) => (
      <FileComponent
        key={`file-${index}`}
        file={file}
        onDelete={() => handleFileDelete(index)}
        className="w-full p-5"
      />
    ));
  };

  const onAcceptGstConfirmation = () => {
    setFormData((prev) => ({
      ...prev,
      address_details: { ...prev?.address_details, state: '' },
      proof_data: '',
      is_gst_registered: false,
      uploadedFiles: [],
      panFileType: 'pdf',
      secondaryFileType: 'pdf',
    }));
    setModalData((prev) => ({
      ...prev,
      isGstConfirmationModalOpen: false,
      isUploadModalOpen: false,
      isUploadAadharModalOpen: false,
    }));
  };

  return (
    <div className="verification-form flex flex-col justify-between gap-4 px-4 md:px-20 pt-16 pb-5 w-full">
      <div className="flex flex-col justify-between gap-8 w-full">
        <div className="label-14 text-grey-70 flex flex-col gap-3">
          GST registration status
          <div className="flex gap-6">
            <Radio
              key = "registered"
              id="registered"
              label="Registered"
              onChange={() => {
                resetFileUploadState();
                setFormData((prev) => ({
                  ...prev,
                  address_details: { ...prev?.address_details, state: '' },
                  proof_data: '',
                  is_gst_registered: true,
                  uploadedFiles: [],
                  panFileType: 'pdf',
                  secondaryFileType: 'pdf',
                }));
              }}
              checked={formData?.is_gst_registered === true}
            />
            <Radio
              key = "not-registered"
              id="not-registered"
              label="Not Registered"
              onChange={() => setModalData((prev) => ({ ...prev, isGstConfirmationModalOpen: true }))}
              checked={formData?.is_gst_registered === false}
            />
          </div>
        </div>
        <Input
          label={
            formData.is_gst_registered
              ? "Registered Company name/Organizer's name"
              : 'Name'
          }
          labelIcon={<Question size={16} color="#878787" className='mt-1'/>}
          value={formData?.company_name}
          onChange={(e) => onChangeData(e, 'company_name')}
          width="100%"
          className="w-full"
        />
        <Input
          label="Address"
          value={formData?.address_details?.address_line_1}
          onChange={(e) => onChangeAddress(e, 'address_line_1')}
          width="100%"
          className="w-full"
        />
        {formData.is_gst_registered ? (
          <>
            <div className="flex flex-col md:flex-row gap-4 w-full md:max-w-[640px]">
              <div className="w-full md:flex-1 md:basis-0 min-w-0">
                <Dropdown
                  label="State"
                  labelIcon={<Question size={16} color="#878787" className='mt-1'/>}
                  width="100%"
                  className="w-full"
                  options={GST_REGISTERED_STATES}
                  value={formData?.address_details?.state}
                  onChange={handleStateChange}
                  hasSearch={true}
                />
              </div>
              <div className="w-full md:flex-1 md:basis-0 min-w-0">
                <Input
                  label="PAN number"
                  value={formData.alternate_proof_data}
                  onChange={handleInputChange('alternate_proof_data')}
                  onBlur={() => validatePanNumber('alternate_proof_data')}
                  helpText={errors.panNumberError}
                  validationStatus={errors.panNumberError ? 'error' : ''}
                  width="100%"
                  className="w-full"
                  maxLength={10}
                />
              </div>
            </div>
            <div className="flex items-center relative">
              <Input
                className="w-full"
                width="100%"
                label="GSTIN number"
                labelIcon={<Question size={16} color="#878787" className='mt-1'/>}
                contentLeft={formData.proof_data.slice(0, 2)}
                value={formData.proof_data.slice(2)}
                onChange={handleGstCodeChange}
                onBlur={() => validateGstCode()}
                helpText={errors.gstCodeError}
                validationStatus={errors.gstCodeError ? 'error' : ''}
                maxLength={13}
              />
              {formData.uploadedFiles.length > 0 && !errors.gstCodeError && (
                <CheckCircle
                  size={24}
                  color={'#009D64'}
                  weight={'fill'}
                  className="verify-check"
                />
              )}
            </div>
          </>
        ) : (
          <div className="flex flex-col gap-3">
            <div className="flex flex-col md:flex-row gap-4 w-full md:max-w-[640px]">
              <div className="w-full md:flex-1 md:basis-0 min-w-0">
                <Dropdown
                  label="State"
                  labelIcon={<Question size={16} color="#878787" className='mt-1'/>}
                  width="100%"
                  className="w-full"
                  options={indianStates}
                  value={formData?.address_details?.state}
                  onChange={handleStateChange}
                  hasSearch={true}
                />
              </div>
              <div className="w-full md:flex-1 md:basis-0 min-w-0 relative">
                <Input
                  label="PAN number"
                  labelIcon={<Question size={16} color="#878787" className="mt-1" />}
                  value={formData.proof_data}
                  onChange={handleInputChange('proof_data')}
                  onBlur={() => validatePanNumber('proof_data')}
                  helpText={errors.panNumberError}
                  validationStatus={errors.panNumberError ? 'error' : ''}
                  width="100%"
                  className="w-full"
                  maxLength={10}
                />
                {formData.uploadedFiles.length > 0 && !errors.panNumberError && (
                  <CheckCircle
                    size={24}
                    color="#009D64"
                    weight="fill"
                    className="verify-check"
                  />
                )}
              </div>
            </div>
            <div className="w-full md:max-w-[640px]">
              <Dropdown
                label="Secondary ID"
                placeholder="Select any Govt ID"
                width="100%"
                className="w-full"
                options={[
                  { id: 'Aadhar Card', label: 'Aadhar Card' },
                  { id: 'Passport', label: 'Passport' },
                  { id: 'Driving License', label: 'Driving License' },
                  { id: 'Others', label: 'Others' },
                ]}
                value={formData.secondary_proof_id}
                onChange={handleSecondaryIdChange}
              />
            </div>
          </div>
        )}
        {isFormValid && (
          <>
            {formData.is_gst_registered ? (
              formData.uploadedFiles.length > 0 ? null : (
                <Button
                  children={'Upload GST Certificate'}
                  iconLeft={<CloudArrowUp size={24} />}
                  type="secondary"
                  className="flex gap-2.5 w-full"
                  onClick={handleFileUpload}
                />
              )
            ) : (
              formData.uploadedFiles.length > 0 ? null : (
                <Button
                  children={`Upload PAN and ${formData.secondary_proof_id}`}
                  iconLeft={<CloudArrowUp size={24} />}
                  type="secondary"
                  className="flex gap-2.5 w-full"
                  onClick={handleFileUpload}
                />
              )
            )}
            {renderUploadedFiles()}
            <div>
              <UploadModal
                isOpen={modalData.isUploadModalOpen}
                onClose={() => setModalData((prev) => ({ ...prev, isUploadModalOpen: false }))}
                uploadTitle={modalData.uploadTitle}
                uploadFileName={modalData.uploadFileName}
                reuploadText={modalData.reuploadText}
                onSubmit={handleFileSubmit}
              />
              <UploadAadharModal
                isOpen={modalData.isUploadAadharModalOpen}
                onClose={() => setModalData((prev) => ({ ...prev, isUploadAadharModalOpen: false }))}
                uploadTitle={modalData.uploadTitle}
                uploadFileName1={modalData.uploadFileName1}
                uploadFileName2={modalData.uploadFileName2}
                reuploadText1={modalData.reuploadText1}
                reuploadText2={modalData.reuploadText2}
                onSubmit={handleFilesSubmit}
                secondaryProofType={formData.secondary_proof_id}
              />
            </div>
          </>
        )}
      </div>
      <div>
        <VendorModal
          isOpen={modalData.isVendorModalOpen}
          onClose={() => setModalData((prev) => ({ ...prev, isVendorModalOpen: false }))}
          onConfirm={handleConfirm}
          organizerName={formData?.company_name}
          loading={acceptLoading}
        />
        <PublishEventModal
          isOpen={modalData.isPublishModalOpen}
          onClose={() => setModalData((prev) => ({ ...prev, isPublishModalOpen: false }))}
          onConfirm={() => setModalData((prev) => ({ ...prev, isVendorModalOpen: true, isPublishModalOpen: false }))}
          eventData={eventData}
        />
        <SuccessModal
          isOpen={modalData.isSuccessModalOpen}
          onConfirm={handleSuccessConfirm}
        />
        <Modal
          title="GST Undertaking"
          primaryText="Accept"
          onClickPrimaryCta={onAcceptGstConfirmation}
          hasClose={true}
          onClose = {() => setModalData((prev) => ({ ...prev, isGstConfirmationModalOpen: false }))}
          isOpen={modalData?.isGstConfirmationModalOpen}
          className="vendor-modal"
          customFooter={(
            <div className="flex justify-center pb-4 pt-4">
            <Button
              className="primary-cta"
              type="primary"
              onClick={onAcceptGstConfirmation}
            >
              Accept
            </Button>
            </div>
          )}>
            <GstForm />
          </Modal>
      </div>
      <div className="py-0 px-4 md:px-20 flex flex-col flex-end gap-4 justify-center items-center w-full">
        <Checkbox
          id=""
          label="I acknowledge and accept the Terms of service and Privacy policy. "
          onChange={handleAcceptedChange}
          checked={isPolicyAccepted}
        />
        <Button
          type="primary-black"
          size="small"
          children="Publish event"
          disabled={isDisabled}
          className="publish-button w-full md:w-auto"
          onClick={() => !isDisabled && handlePublishEvent()}
        />
      </div>
    </div>
  );
};

export default VerificationForm;
